<div class="bg-login">
    <div class="container h-100">
        <div class="wrap text-center h-100 align-content-center">
            <div class="col-12 row m-0 p-0">
                <div class="col-3"></div>
                <div class="col-12 col-lg-6 bg-f-w justify-content-center z-100 mt-4">
                    <div class="col-12 m-0 row">
                        <div class="col-2"></div>
                        <div class="col-12 col-md-8 p-0 mt-4">
                            <div class="col-12 text-center p-0 mt-4">
                                <img src="../../assets/images/rekruu_logo.png" alt="" height="110"
                                    class="mx-auto">
                                <h4 class="semiboldtextblue90024 mt-4">Tervetuloa</h4>
                                <p class="normaltextblue90016 f-os mt-2">Rekisteröi organisaatiosi palveluun. Varmennamme
                                    kaikki rekisteröityvät organisaatiot.</p>
                            </div>
                        </div>
                        <div class="col-2"></div>

                    </div>

                    <div class="col-12 p-0 row m-0">
                        <div class="col-1"></div>
                        <div class="col-12 col-md-10 p-0">
                            <div class="col-12 p-0 ">
                                <div class="col-12 login-form-bg pb-4">
                                    <div class="alert alert-danger" id="err-lock" style="display: none;">
                                        <p class="body2b-b">{{error_message}} </p>
                                    </div>
                                    <div class="alert alert-success" id="success_message" style="display: none;">
                                        <p class="body2b-b">Onnistui! Jatko-ohjeet on lähetetty sähköpostiisi.</p>
                                    </div>
                                    <button (click)="faker()" id="ss-btn" style="display: none;"></button>
                                    <div id="loader" class="loader-container mt-4 mb-4" style="display: none;">
                                        <div class="loader mx-auto"></div>
                                        <p class="body2b-b text-center mt-4 mb-4">Rekisteröidytään...</p>
                                    </div>
                                    <div class="" id="form-container">
                                        <form class="flex-row "  id="login-form" [formGroup]="form"
                                            (ngSubmit)="renderReCaptch()">

                                            <!-- Sähköposti -->
                                            <div class="col-12 row m-0 pt-2">
                                                <div class="form-floating mb-2  col-12 col-md-12 p-0">
                                                    <input type="text" placeholder="Yrityksen nimi"
                                                        formControlName="businessName" id="businessName"
                                                        class="form-control" required>
                                                    <label for="businessName">Yrityksen nimi</label>
                                                </div>
                                            </div>
                                            <!-- Sähköposti -->
                                            <div class="col-12 row m-0 pt-2">
                                                <div class="form-floating mb-2  col-12 col-md-12 p-0">
                                                    <input type="text" placeholder="Y-tunnus" formControlName="vatID"
                                                        id="vatID" class="form-control" required>
                                                    <label for="vatID">Y-tunnus</label>
                                                </div>
                                            </div>
                                            <!-- Salasana -->
                                            <div class="col-12 row m-0 pt-2">
                                                <div class="form-floating mb-2  col-12 col-md-12 p-0">
                                                    <input type="text" placeholder="Etunimi"
                                                        formControlName="main_firstName" id="main_firstName"
                                                        class="form-control" required>
                                                    <label for="main_firstName">Etunimi</label>
                                                </div>
                                            </div>
                                            <!-- Salasana -->
                                            <div class="col-12 row m-0 pt-2">
                                                <div class="form-floating mb-2  col-12 col-md-12 p-0">
                                                    <input type="text" placeholder="Sukunimi"
                                                        formControlName="main_lastName" id="main_lastName"
                                                        class="form-control" required>
                                                    <label for="main_lastName">Sukunimi</label>
                                                </div>
                                            </div>
                                            <!-- Salasana -->
                                            <div class="col-12 row m-0 pt-2">
                                                <div class="form-floating mb-2  col-12 col-md-12 p-0">
                                                    <input type="text" placeholder="Puhelinnumerosi"
                                                        formControlName="main_phone" id="main_phone"
                                                        class="form-control" required>
                                                    <label for="main_phone">Puhelinnumerosi</label>
                                                </div>
                                            </div>
                                            <!-- Salasana -->
                                            <div class="col-12 row m-0 pt-2">
                                                <div class="form-floating mb-2  col-12 col-md-12 p-0">
                                                    <input type="text" placeholder="Sähköpostiosoitteesi"
                                                        formControlName="main_email" id="main_email"
                                                        class="form-control" required>
                                                    <label for="main_email">Sähköpostiosoitteesi</label>
                                                </div>
                                            </div>
                                            <div class=" mx-auto mt-2 pb-4">
                                                <div class="text-center">
                                                    <button #recaptcha [disabled]="form.invalid"
                                                        class="btn btn-formed-main-blue w-100">Rekisteröidy</button>
                                                </div>
                                            </div>
                                        </form>
                                    </div>

                                </div>
                            </div>
                        </div>
                        <div class="col-1"></div>

                    </div>

                </div>
                <div class="col-3"></div>
            </div>

        </div>
    </div>

</div>